import React from "react";
import styled from "styled-components";
import TagList from "components/foundation/Tag/TagList";
import TagPageBoard from "pages/tag/TagPageBoard";
import Divider from "components/foundation/Divider";
import Button from "components/foundation/Button";
import { FileIcon } from "assets/icons";
import TagPageListItem from "pages/tag/TagPageListItem";
import { DocumentCategoryWithTagsResponse } from "apis/data-contracts";
import { Link } from "react-router-dom";
import { ROUTER_PATH } from "config/path";
import { useDocumentClassesByCategoryQuery } from "features/document/hooks/queries/useDocumentClassesByCategoryQuery";

interface TagDetailWebPageProps {
  data: DocumentCategoryWithTagsResponse;
  id: string;
}

const TagDetailWebPage = ({ data, id }: TagDetailWebPageProps) => {
  const { data: documentClasses } = useDocumentClassesByCategoryQuery(id);

  return (
    <TagDetailPageLayout>
      <h1>태그조회</h1>
      <TagPageListItem title="문서종류">
        <p>{data.documentCategoryName}</p>
      </TagPageListItem>

      <TagPageListItem title="문서구분태그">
        <TagList
          list={documentClasses.map((documentClass) => documentClass.name)}
        />
      </TagPageListItem>
      {data.tagCategories.map((tag) => {
        return (
          <TagPageListItem
            title={`${tag.tagCategoryName}태그`}
            key={tag.tagCategoryUuid}
          >
            <TagList list={tag.tags.map((i) => i.tagName)} />
          </TagPageListItem>
        );
      })}
      <Divider />
      <div className="detail-page__footer">
        <Link to={ROUTER_PATH.tag.dashboard._path}>
          <Button variant="tertiary" size="large">
            목록
            <FileIcon />
          </Button>
        </Link>
        <Link to={ROUTER_PATH.tag.dashboard.detail.edit(id)}>
          <Button size="large">수정</Button>
        </Link>
      </div>
    </TagDetailPageLayout>
  );
};

export default TagDetailWebPage;

const TagDetailPageLayout = styled(TagPageBoard)`
  .detail-page__footer {
    display: flex;
    justify-content: space-between;
  }
`;
